export enum ChatMessageRole {
  USER = "user",
  ASSISTANT = "assistant",
}
